import { render, staticRenderFns } from "./SubProjectStatus.vue?vue&type=template&id=2ca02c76&scoped=true&"
import script from "./SubProjectStatus.vue?vue&type=script&lang=js&"
export * from "./SubProjectStatus.vue?vue&type=script&lang=js&"
import style0 from "./SubProjectStatus.vue?vue&type=style&index=0&id=2ca02c76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca02c76",
  null
  
)

export default component.exports